<template>
    <div class="of-content1-description-skeleton">
        <div class="of-content1-description">
            <h1 v-html="description.title" ></h1>
            <p v-html="description.text" ></p>
        </div>
        <ba-franchise-modals-v5
            class="of-content1-buttons"
            id="of-content1-buttons"
        />
    </div>
</template>

<script>
    export default {
        name: 'description',
        props: ['view'],
        data() {
            return {
                title: "Dashboard Funnel Club",
                text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat. Nunc facilisis auctor donec etiam mauris laoreet. Nunc sollicitudin nostra vestibulum. Quisque sodales purus amet nostra mattis eget placerat vehicula vulputate. Interdum leo inceptos lectus imperdiet vehicula ultrices sit.',
                urlConnectedDomain: '',
            }
        },
        computed: {
            description: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        methods:{
        },
        created(){

        },
        mounted(){
        }
    }
</script>

<style lang="scss">
    @import "../../../../../scss/office";
    .of-content1-description-skeleton {
        font: inherit;
        display: grid;
        grid-template-columns: repeat(10, 1fr);
        grid-template-rows: auto;
        column-gap: 2.6229508%; /* 32px */
        row-gap: 3.2em; /* 32px */
        justify-items: stretch;
        align-items: stretch;
        justify-content: stretch;
        align-content: stretch;

        .of-content1-description {
            font: inherit;
            text-align: left;

            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 1;
            grid-column-end: 7;

            h1{
                font-family: $of-font1;
                font-size: 5em; /* 50px */
                font-weight: 700;
                color: $of-color1;
                margin: 0 0 0.24em 0; /* 12px */
                line-height: 1.2;
            }
            p{
                // font-size: 1.4em; /* 14px */
                font-size: 14px; /* 14px */
                line-height: 1.2;
                margin: 0;
                color: $of-color2;
            }
        }
        #of-content1-buttons{
            font: inherit;

            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 7;
            grid-column-end: 11;
            .tabs__funnel{
                font: inherit;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                row-gap: 1.2em;

                &::after,
                &::before{
                    display: none;
                }

                li {
                    font:inherit;
                    width: 100%;
                    // padding: 0 1rem;
                    .d-button{
                        width: 100%;

                        font: inherit;
                        font-size: 1.8em; /* 14px */
                        font-weight: 500;
                        display: block;
                        background: $of-color1;
                        padding: 0.714285714em 1.071428571em; /* 10px 15px */
                        color: $of-color3;
                        border-radius: 4px;
                        transition: 1s all ease;
                        // margin: 0 0 1.857142857em 0; /*26px */
                        text-align: center;

                        outline: none!important;
                        border: none;
                        &:hover {
                            cursor: pointer;
                            box-shadow: 0px 0px 7px -2px $of-color1;
                        }
                    }
                    .dropdown-menu{
                        width: 100%;
                        font-family: Lato;
                    }
                }
            }
            .loading-buttons{
                height: 100px;
                text-align: center;
                border-radius: 0!important;
                border: 0!important;
                .modal-loader{
                    height: 70px;
                    width: auto;
                }
            }
        }
    }

    @media (max-width: 768px) { /* smartphones e tablets */
        .of-content1-description-skeleton {
            font: inherit;

            grid-template-columns: repeat(10, 1fr);
            grid-template-rows: repeat(2, auto);
            column-gap: 0;
            row-gap: 3.2em; /* 32px */

            .of-content1-description {
                grid-row-start: 1;
                grid-row-end: 2;
                h1{
                    font-size: 6em; /* 60px */
                }
                p{
                    font-size: 1.68em; /* 16.8px */
                }
            }
            #of-content1-buttons{
                grid-row-start: 2;
                grid-row-end: 3;
            }

            .of-content1-description,
            #of-content1-buttons{
                grid-column: span 10;
            }            
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-1/description.vue